var _style, _defs, _defs2, _defs3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs4, _path9, _defs5, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99 100",
    style: {
      enableBackground: "new 0 0 99 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);}\r\n\t.st1{clip-path:url(#SVGID_4_);}\r\n\t.st2{clip-path:url(#SVGID_6_);fill:#515151;}\r\n\t.st3{clip-path:url(#SVGID_6_);fill:#424242;}\r\n\t.st4{clip-path:url(#SVGID_6_);fill:#303030;}\r\n\t.st5{clip-path:url(#SVGID_6_);}\r\n\t.st6{clip-path:url(#SVGID_6_);fill:#FF5B5C;}\r\n\t.st7{clip-path:url(#SVGID_6_);fill:#1E1E1E;}\r\n\t.st8{clip-path:url(#SVGID_6_);fill:#E91C31;}\r\n\t.st9{opacity:0.4;clip-path:url(#SVGID_6_);}\r\n\t.st10{clip-path:url(#SVGID_8_);fill:#C6C6C6;}\r\n\t.st11{clip-path:url(#SVGID_10_);fill:#C6C6C6;}\r\n\t.st12{clip-path:url(#SVGID_6_);fill:#FED206;}\r\n\t.st13{clip-path:url(#SVGID_6_);fill:#FEE619;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "SnapIt_1_"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 3.7,
    y: 4.1,
    width: 94.3,
    height: 90.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 3.7,
    y: 4.1,
    width: 94.3,
    height: 90.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: 3.7,
    y: 4.1,
    width: 94.3,
    height: 90.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25.9,26.9c0-2.8,2.3-9,5.1-9h36.6c2.8,0,5.1,6.2,5.1,9h18.6c2,0,3.6,1.6,3.6,3.6v57.4c0,2-1.6,3.6-3.6,3.6 h-84c-2,0-3.6-1.6-3.6-3.6V30.5c0-2,1.6-3.6,3.6-3.6H25.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M16.9,91.5H7.3c-2,0-3.6-1.6-3.6-3.6V30.5c0-2,1.6-3.6,3.6-3.6h9.6c0,0-4.7,4-4.7,10v45.1 C12.2,82.1,11.9,87.9,16.9,91.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M42.9,18H31c-2.8,0-5.1,6.2-5.1,9C25.9,26.9,29.6,20,42.9,18"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M81.9,61.9c0,18-14.6,32.6-32.6,32.6c-18,0-32.6-14.6-32.6-32.6s14.6-32.6,32.6-32.6 C67.3,29.3,81.9,43.9,81.9,61.9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M71.2,61.9c0,12.1-9.8,21.9-21.9,21.9c-12.1,0-21.9-9.8-21.9-21.9c0-12.1,9.8-21.9,21.9-21.9 C61.4,39.9,71.2,49.8,71.2,61.9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M18.4,34.5c0,2.2-1.8,4-4,4c-2.2,0-4-1.8-4-4s1.8-4,4-4C16.7,30.5,18.4,32.3,18.4,34.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M19.1,26.9H9.8c-1.2,0-2.2-1-2.2-2.2c0-1.2,1-2.2,2.2-2.2h9.3c1.2,0,2.2,1,2.2,2.2 C21.4,25.9,20.3,26.9,19.1,26.9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M14.4,38.5c-2.2,0-4-1.8-4-4c0-2.2,1.8-4,4-4c0,0-2,1.1-2,4C12.4,37.4,14.4,38.5,14.4,38.5"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: 60.6,
    y: 54.7,
    width: 7.2,
    height: 7.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M67.8,58.3c0,2-1.6,3.6-3.6,3.6c-2,0-3.6-1.6-3.6-3.6c0-2,1.6-3.6,3.6-3.6 C66.2,54.7,67.8,56.3,67.8,58.3"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_9_",
    x: 62,
    y: 64.7,
    width: 4.6,
    height: 4.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M66.5,67c0,1.3-1,2.3-2.3,2.3S62,68.3,62,67c0-1.3,1-2.3,2.3-2.3S66.5,65.8,66.5,67"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M89.9,39.4c-0.5,0.5-2.7,2.6-3.6,6c-0.2,1.2-1.1,2-2.1,2.1h0c-1-0.1-1.9-0.9-2.1-2.1 c-0.9-3.4-3.1-5.5-3.6-6c-0.5-0.5-2.6-2.7-6-3.6c-1.2-0.2-2-1.1-2.1-2.1v0c0.1-1,0.9-1.9,2.1-2.1c3.4-0.9,5.5-3.1,6-3.6 c0.5-0.5,2.7-2.6,3.6-6c0.2-1.2,1.1-2,2.1-2.1h0c1,0.1,1.9,0.9,2.1,2.1c0.9,3.4,3.1,5.5,3.6,6c0.5,0.5,2.6,2.7,6,3.6 c1.2,0.2,2,1.1,2.1,2.1v0c-0.1,1-0.9,1.9-2.1,2.1C92.5,36.7,90.4,38.9,89.9,39.4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M79,15.3c-0.3,0.3-1.6,1.5-2.1,3.4c-0.1,0.7-0.6,1.2-1.2,1.2h0c-0.6,0-1.1-0.5-1.2-1.2 c-0.5-1.9-1.8-3.1-2.1-3.4C72.2,15,71,13.7,69,13.2c-0.7-0.1-1.2-0.6-1.2-1.2v0c0-0.6,0.5-1.1,1.2-1.2c1.9-0.5,3.1-1.8,3.4-2.1 c0.3-0.3,1.6-1.5,2.1-3.4c0.1-0.7,0.6-1.2,1.2-1.2h0c0.6,0,1.1,0.5,1.2,1.2c0.5,1.9,1.8,3.1,2.1,3.4c0.3,0.3,1.5,1.6,3.4,2.1 c0.7,0.1,1.2,0.6,1.2,1.2v0c0,0.6-0.5,1.1-1.2,1.2C80.5,13.7,79.3,15,79,15.3"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.6f36c4bc8b872f38cbaf872bd81ca965.svg";
export { ForwardRef as ReactComponent };